import { useRef, useCallback } from "react"
import { useHistory, useLocation } from "react-router-dom"

const int = (v) => {
	const n = parseInt(v, 10)
	return Number.isFinite(n) ? n : 0
}

const FILTER_KEYS = {
	stock: ["categorie", "lowOnly", "aCommanderOnly"],
	commandes: ["fournisseur", "article"],
	stockVirtuel: ["fournisseur", "mois", "annee"],
	commandesVirtuelles: ["fournisseur", "annulees"],
	utilisations: ["cat", "article"],
}

export function readUrlState(search, visibleTabKeys) {
	const q = new URLSearchParams(search)
	let tab = q.get("tab")
	if (!tab || !visibleTabKeys.includes(tab))
		tab = visibleTabKeys[0] || "stock"

	return {
		tab,
		stock: {
			categorie: int(q.get("categorie")),
			lowOnly: q.get("lowOnly") === "1",
			aCommanderOnly: q.get("aCommanderOnly") === "1",
		},
		commandes: {
			fournisseur: int(q.get("fournisseur")),
			article: int(q.get("article")),
		},
		stockVirtuel: {
			fournisseur: int(q.get("fournisseur")),
			mois: int(q.get("mois")),
			annee: int(q.get("annee")),
		},
		commandesVirtuelles: {
			fournisseur: int(q.get("fournisseur")),
			annulees: q.get("annulees") === "1",
		},
		utilisations: {
			cat: int(q.get("cat")),
			article: int(q.get("article")),
		},
	}
}

export function buildSearch(tab, filters) {
	const q = new URLSearchParams()
	q.set("tab", tab)
	const keys = FILTER_KEYS[tab]
	if (keys && filters) {
		for (const k of keys) {
			const v = filters[k]
			if (v !== undefined && v !== 0 && v !== false && v !== "0") {
				q.set(k, typeof v === "boolean" ? "1" : String(v))
			}
		}
	}
	return q.toString()
}

export default function useInventaireUrlState(visibleTabKeys) {
	const history = useHistory()
	const location = useLocation()
	const initial = useRef(readUrlState(location.search, visibleTabKeys))

	const syncUrl = useCallback(
		(tab, filters) => {
			const search = buildSearch(tab, filters)
			history.replace({ pathname: location.pathname, search })
		},
		[history, location.pathname],
	)

	return { initial: initial.current, syncUrl }
}
